import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    allowEmailData: null,
    denyEmailData: null,
    allowTextData: null,
    denyTextData: null,
  },
  action
) {
  switch (action.type) {
    case homeConstants.ALLOW_EMAIL_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        isProgress: true,
      };
    case homeConstants.ALLOW_EMAIL_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        allowEmailData: action.response,
        isProgress: false,
      };
    case homeConstants.ALLOW_EMAIL_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        allowEmailData: null,
        error: action.error,
        isProgress: false,
      };
    case homeConstants.DENY_EMAIL_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        isProgress: true,
      };
    case homeConstants.DENY_EMAIL_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        denyEmailData: action.response,
        isProgress: false,
      };
    case homeConstants.DENY_EMAIL_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        denyEmailData: {},
        isProgress: false,
      };

    case homeConstants.ALLOW_TEXT_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        isProgress: true,
      };
    case homeConstants.ALLOW_TEXT_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        allowTextData: action.response,
        isProgress: false,
      };
    case homeConstants.ALLOW_TEXT_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        allowTextData: {},
        error: action.error,
        isProgress: false,
      };

    case homeConstants.DENY_TEXT_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        isProgress: true,
      };
    case homeConstants.DENY_TEXT_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        denyTextData: action.response,
        isProgress: false,
      };
    case homeConstants.DENY_TEXT_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        denyTextData: {},
        isProgress: false,
      };
    case homeConstants.RESET_NOTIFICATIONS_REMINDER_INFO:
      return {
        ...state,
        allowEmailData: null,
        denyEmailData: null,
        allowTextData: null,
        denyTextData: null,
        isProgress: false,
      };
    default:
      return state;
  }
}
